export default {
    ADD_PRODUCT(state, product) {
      state.products.unshift(product);
      state.totalDataRow++;
    },
    SET_PRODUCT(state, res) {
      state.products = res.items
      state.totalDataRow = res.totalCount;
    },
    UPDATE_PRODUCT(state, product) {
      const productIndex = state.products.findIndex((p) => p.id == product.id)
      Object.assign(state.products[productIndex], product)
    },
    REMOVE_PRODUCT(state, productId) {
      const productIndex = state.products.findIndex((p) => p.id == productId)
      state.products.splice(productIndex, 1)
    },
  }
  